import { useEffect, useState } from 'react';

import { BUILDER_BOTTOM_NAVIGATION_ID } from '~/constants/common';

export default function useBuilderBottomNavigationElement() {
  const [bottomNavigationElement, setBottomNavigationElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const element = document.getElementById(BUILDER_BOTTOM_NAVIGATION_ID);

    if (element) {
      setBottomNavigationElement(element);
    }
  }, []);

  return { bottomNavigationElement };
}
